import './src/scss/_index.scss';
import React from 'react';
import { GlobalContextProviderComponent } from './src/context/global-context';

export const wrapRootElement = ({ element }) => (
	<GlobalContextProviderComponent>{element}</GlobalContextProviderComponent>
);